import React, { useState, useCallback, useEffect } from "react";
import Heading from "../../../../common/element/Heading";
import Segment from "../../../../common/element/Segment";
import Table from "../../../../common/element/Table";
import Badge from "../../../../common/element/Badge";
import Tag from "../../../../common/element/Tag";
import Scrollbar from "../../../../common/element/ScrollBar";
import BtnLight from "../../../../common/element/Buttons/btnLight";
import { useDispatch } from "react-redux";
import { setBreadcrumbs } from "../../../../redux/classes/breadcrumbsSlice";
import Tasks from "./Tasks";
import Inductions from "./Inductions";
import Documents from "./Documents";
import { useNavigate } from "react-router-dom";
const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    // Set breadcrumbs when the component mounts
    dispatch(
      setBreadcrumbs([{ label: "Dashboard", url: "/worker/dashboard" }])
    );
  }, []);
  const [singleSegmentValue, setSingleSegmentValue] = useState(["Index"]);

  const { Tr, Th, Td, THead, TBody } = Table;
  const onSingleSelectionSegmentChange = useCallback(
    (val) => {
      setSingleSegmentValue(val);
    },
    [setSingleSegmentValue]
  );
  return (
    <React.Fragment>
      <Heading className="mb-4">Dashboard</Heading>
      <div className="grid grid-container gap-8">
        <div className="flex gap-8 flex-col">
          <Tasks />
        </div>
        <div className="flex gap-8 flex-col">
          <Inductions />
         
          <div className="flex gap-8 flex-col">
            <Documents/>
     
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
